// ./auth.js
import Cookies from "js-cookie";

/* ---------------- Security Constants ---------------- */
const TOKEN_MAX_LENGTH = 5000; // جلوگیری از توکن‌های خیلی بزرگ (DoS)

/* ---------------- Token Access ---------------- */
export function getAccessToken() {
  const token = Cookies.get("access_token") || null;
  if (token && token.length > TOKEN_MAX_LENGTH) {
    removeTokens();
    return null;
  }
  return token;
}

export function getRefreshToken() {
  const token = Cookies.get("refresh_token") || null;
  if (token && token.length > TOKEN_MAX_LENGTH) {
    removeTokens();
    return null;
  }
  return token;
}

export function getTokenTime() {
  return Cookies.get("token_time") || null;
}

/* ---------------- CSRF Token ---------------- */
export function getCsrfToken() {
  return Cookies.get("csrf_token") || null;
}

export function setCsrfToken(token) {
  const opt = {
    expires: 8 / 24,
    secure: true,
    sameSite: "None",
  };
  Cookies.set("csrf_token", token, opt);
}

// ژنراتور امن CSRF (Double-Submit Cookie)
export function ensureCsrfToken() {
  if (typeof window === "undefined") return null;

  let token = getCsrfToken();
  if (!token) {
    let value = "";

    if (window.crypto && window.crypto.getRandomValues) {
      const arr = new Uint8Array(32);
      window.crypto.getRandomValues(arr);
      value = Array.from(arr)
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
    } else {
      value =
        Math.random().toString(36).substring(2) +
        Date.now().toString(36);
    }

    token = value;
    setCsrfToken(token);
  }

  return token;
}

/* ---------------- Token Store ---------------- */
export function setTokens(accessToken, refreshToken, dateTimeNow) {
  const opt = {
    expires: 8 / 24,
    secure: true,
    sameSite: "None", // برای کار با subdomain (emrapi.shafa33.ir)
  };

  Cookies.set("access_token", accessToken, opt);
  Cookies.set("refresh_token", refreshToken, opt);
  Cookies.set("token_time", String(dateTimeNow), opt);
}

/* ---------------- Token Remove ---------------- */
export function removeTokens() {
  Cookies.remove("access_token");
  Cookies.remove("refresh_token");
  Cookies.remove("token_time");
  Cookies.remove("csrf_token");

  if (typeof window !== "undefined") {
    try {
      // پاک کردن state سمت کلاینت (هر چه در sessionStorage داشتی)
      sessionStorage.clear();
      // قفل رفرش را هم اگر در localStorage ذخیره شده، حذف کن
      localStorage.removeItem("shafa33_refresh_lock");
      sessionStorage.removeItem("shafa33_auth_sync");
    } catch {
      // ignore
    }
  }
}

/* ---------------- Token Expiration Check ---------------- */
export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return true;

    // تبدیل base64url به base64
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    const payload = JSON.parse(jsonPayload);
    const exp = payload.exp * 1000;
    return Date.now() >= exp;
  } catch {
    return true;
  }
}
